export let SWAG_BUNDLE_ADD_ONS_STEPS = /*#__PURE__*/function (SWAG_BUNDLE_ADD_ONS_STEPS) {
  SWAG_BUNDLE_ADD_ONS_STEPS["BOX_TYPE_SELECTION"] = "BOX_TYPE_SELECTION";
  SWAG_BUNDLE_ADD_ONS_STEPS["CUSTOM_BOX_SELECTION"] = "CUSTOM_BOX_SELECTION";
  SWAG_BUNDLE_ADD_ONS_STEPS["FULLY_CUSTOM_BOX_SELECTION"] = "FULLY_CUSTOM_BOX_SELECTION";
  SWAG_BUNDLE_ADD_ONS_STEPS["COLORED_BOX_SELECTION"] = "COLORED_BOX_SELECTION";
  SWAG_BUNDLE_ADD_ONS_STEPS["BROWN_BOX_SELECTION"] = "BROWN_BOX_SELECTION";
  SWAG_BUNDLE_ADD_ONS_STEPS["NOTECARD_SELECTION"] = "NOTECARD_SELECTION";
  return SWAG_BUNDLE_ADD_ONS_STEPS;
}({});
export let SWAG_BUNDLE_ORDER_MORE_STEPS = /*#__PURE__*/function (SWAG_BUNDLE_ORDER_MORE_STEPS) {
  SWAG_BUNDLE_ORDER_MORE_STEPS["ORDER_MORE_PRODUCTS_SELECTION"] = "ORDER_MORE_PRODUCTS_SELECTION";
  SWAG_BUNDLE_ORDER_MORE_STEPS["ORDER_MORE_ADDONS_CHEKOUT"] = "ORDER_MORE_ADDONS_CHEKOUT";
  SWAG_BUNDLE_ORDER_MORE_STEPS["ORDER_MORE_PAYMENT"] = "ORDER_MORE_PAYMENT";
  SWAG_BUNDLE_ORDER_MORE_STEPS["ORDER_MORE_SUCCESS"] = "ORDER_MORE_SUCCESS";
  return SWAG_BUNDLE_ORDER_MORE_STEPS;
}({});
export let SWAG_BUNDLE_ORDER_MORE_SELECTION_PRODUCT_TYPES = /*#__PURE__*/function (SWAG_BUNDLE_ORDER_MORE_SELECTION_PRODUCT_TYPES) {
  SWAG_BUNDLE_ORDER_MORE_SELECTION_PRODUCT_TYPES["SELECTED_PRODUCT"] = "SELECTED_PRODUCT";
  SWAG_BUNDLE_ORDER_MORE_SELECTION_PRODUCT_TYPES["SELECTED_ADD_ONS"] = "SELECTED_ADD_ONS";
  return SWAG_BUNDLE_ORDER_MORE_SELECTION_PRODUCT_TYPES;
}({});